import Cookies from 'js-cookie'

export function setToken(value) {
    // 根据当前环境动态设置domain和secure
    const isProduction = window.location.hostname.endsWith('mmming.cn');
    const options = {
      expires: 7,
      path: '/',
      ...(isProduction && { domain: '.mmming.cn' })
    };

    // 优先使用localStorage存储
    localStorage.setItem('token', value);
    
    try {
      // 尝试设置cookie，如果失败则只使用localStorage
      if (isProduction) {
        // 生产环境使用更严格的设置
        options.secure = true;
        options.sameSite = 'None';
      }
      Cookies.set('token', value, options);
    } catch (error) {
      console.warn('Cookie设置失败，将只使用localStorage存储token');
    }
  
    return value;
}

export function getToken() {
    // 优先从localStorage获取
    const token = localStorage.getItem('token');
    if (token) {
        return token;
    }
    // 如果localStorage没有，则尝试从cookie获取
    return Cookies.get("token");
}

export function removeToken() {
    localStorage.removeItem('token');
    return Cookies.remove("token");
}

export function setUrl(value) {
    return window.sessionStorage.setItem("baseUrl", value)
}

export function getUrl() {
    return window.sessionStorage.getItem("baseUrl")
}

export function setNotice(value) {
    return Cookies.set("notice", value, { expires: 90 });
}

export function getNotice() {
    return Cookies.get("notice");
}
